import { FunctionComponent, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import BasicButton from "@components/core/buttons/BasicButton";

interface SubmitButtonProps {
  isSubmitting?: boolean;
  label: string;
  className?: string;
  disabled?: boolean;
  dataAlt?: string;
  title?: string;
}

const SubmitButton: FunctionComponent<SubmitButtonProps> = ({
  label,
  isSubmitting = false,
  className = "",
  disabled = false,
  dataAlt,
  title,
}: SubmitButtonProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <BasicButton
      type="submit"
      isLoading={isSubmitting}
      text={t(label)}
      data-test={"button"}
      data-alt={dataAlt ?? t("buttons.next")}
      className={className}
      disabled={disabled}
      title={title}
    />
  );
};

export default SubmitButton;
